<div class="reservation-item__container">
  <span class="reservation-changed" *ngIf="reservation?.reservationStatus === 'WaitingApprovalChanged'">{{ 'RESERVATIONS.RESERVATION_CHANGED' | translate }}</span>
  <div class="row align-items-center">
    <div class="col-3">
        <div class="label">{{ 'RESERVATIONS.NAME' | translate }}</div>
        <p class="pt-2">{{reservation?.subscriber?.name}}</p>
    </div>
    <div class="col-3">
          <div class="label">{{ 'RESERVATIONS.GUESTS' | translate }}</div>
            <div class="d-flex flex-row align-items-center">
              <i><mat-icon>person</mat-icon></i>
              <p class="ps-1 pt-2">{{reservation?.numberOfPeoples}}</p>
          </div>
    </div>
    <div class="col-3">
        <div class="label">{{ 'RESERVATIONS.TIMESTAMP' | translate }}</div>
            <p class="pt-2 date-time">{{reservation?.createDate}}</p>
        </div>
    <div class="col-3">
       <div class="event-item__actions d-flex flex-row w-100">
              <container-element class="w-100" [ngSwitch]="reservation?.reservationStatus">
                <div *jrSwitchCases="['WaitingApproval', 'WaitingApprovalChanged']">
                  <div class="d-flex flex-column w-100">
                    <div *ngIf="loading" class="row">
                      <div class="col-12">
                        <mat-spinner class="api-data-spinner"></mat-spinner>
                      </div>
                    </div>
                    <div *ngIf="!loading" class="row">
                      <div class="col-6">
                        <button class="btn btn-gradient-border" (click)="openMore(reservation?.id)">{{ 'MORE' | translate }}</button>
                      </div>
                      <div class="col-6">
                        <button class="btn btn-gradient-border" (click)="refuseReservation(reservation?.id)">{{ 'DECLINE' | translate }}</button>
                      </div>
                      <div class="col-12">
                        <button class="btn btn-full" (click)="confirmReservation(reservation?.id)">{{ 'CONFIRM' | translate }}</button>
                      </div>
                    </div>
                  </div>
                </div>
                
                <div *ngSwitchCase="'Approved'">
                  <div class="d-flex flex-column">
                    <!-- <div class="event-item__actions__published d-flex flex-row gap-1"> -->
                    <div class="row">
                      <div class="col-12">
                        <button class="btn btn-full" (click)="openConfirmedDetails(reservation?.id)">{{ 'DETAILS' | translate }}</button>
                        <!-- <button class="btn btn-gradient-border">Rescind Reservation</button> -->
                      </div>
                    </div>
                    <!-- </div> -->
                  </div>
                </div>
                
                <div *ngSwitchCase="'Refused'">
                  <div class="d-flex flex-column">
                    <div class="row">
                      <div class="col-12">
                        <button class="btn btn-full" (click)="openRefusedDetails(reservation?.id)">{{ 'DETAILS' | translate }}</button>
                      </div>
                    </div>
                  </div>
                </div>

                <div *ngSwitchCase="'Seated'">
                  <div class="d-flex flex-column">
                    <div class="row">
                      <div class="col-12">
                        <button class="btn btn-full" (click)="openRefusedDetails(reservation?.id)">{{ 'DETAILS' | translate }}</button>
                      </div>
                    </div>
                  </div>
                </div>

                <div *ngSwitchCase="'Canceled'">
                  <div class="d-flex flex-column">
                    <div class="row">
                      <div class="col-12">
                        <button class="btn btn-full" (click)="openCanceledDetails(reservation?.id)">{{ 'DETAILS' | translate }}</button>
                      </div>
                    </div>
                  </div>
                </div>
                
                <div *ngSwitchCase="'Finished'">
                  <div>finished</div>
                </div>
                
                
                <div *ngSwitchDefault>...</div>
              </container-element>
        </div>
    </div>
  </div>
</div>